import * as Yup from "yup";

const OBJECT_ID_REGEX = /^[a-f\d]{24}$/i;

export const getSubIndustryValidationSchema = (  isEditing = false,
  hasExistingImage = false,
) =>
  Yup.object({
    title: Yup.string()
      .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
      .required("Sub industry title is required"),

    slug: Yup.string()
      .matches(
        /^[a-z0-9-]+$/,
        "Slug must contain lowercase letters, numbers and hyphens only",
      )
      .required("Slug is required"),

    image:
      isEditing && hasExistingImage
        ? Yup.mixed().nullable()
        : Yup.mixed().required("Sub industry image is required"),

    parentIndustry: Yup.string()
      .trim()
      .required("Parent industry is required")
      .matches(
        OBJECT_ID_REGEX,
        "Parent industry must be a valid 24-character ID",
      )
      .test(
        "not-reserved",
        "Invalid parent industry ID",
        (value) => !value || value.toLowerCase() !== "all",
      ),
  });

export const subIndustryValidationSchema = getSubIndustryValidationSchema();
